import React from 'react'
import {ServerConfig} from 'config'

import PaginatedList from '../../components/PaginatedList/PaginatedList'

const EcocontrolScans = () => {
  const non_editable_fields = [
    ["id", "id", ""],
  ];

  const editable_fields = [
    ["first_name", "First Name"],
    ["last_name", "Last Name"],
    //["street", "Street"],
    //["zip", "ZipCode"],
    ["city", "City"],
    ["state", "State"],
    ["email", "Email"],
    ["phone_number", "Phone Number"]
  ];

const view_fields = [
  ['', 'Ecocontrol', 'header'],
  ['id', 'Ecocontrol ID'],
  ['name', 'EcoControl Name'],

  ['', 'Tenant Site', 'break'],
  ['name', 'Site Name'],
  ['tenant_site.id', 'Site ID'],
  ['tenant_site.phone_number', 'Site Phone Number'],
  ['tenant_site.street', 'Street'],
  ['tenant_site.city', 'City'],
  ['tenant_site.state', 'State'],
  ['tenant_site.zip', 'Zip Code'],
  ['tenant_site.cert_id', 'Cert ID'],
];

  return (
    <>
      <PaginatedList
        list_get_url={`${ServerConfig.SERVER_URL}/tenant/ecocontrol_scans_v2/`}
        view_request={(row) => `${ServerConfig.SERVER_URL}/tenant/ecocontrols/${row.ecocontrol_id}`}
        column_names={["timestamp", "ecocontrol_name", "ecocontrol_id", "qrcode", "first_name", "last_name", "email", "phone_number", "valid", "reason"]}
        header_names={["Time", "EC Name", "EC ID", "Code", "First name", "Last name", "Email", "Phone number", "Valid", "Reason"]}

        optional_column_names={[]}
        optional_header_names={[]}
        view_fields={view_fields}
        filter_inputs={[]}

        editable_fields={editable_fields}
        non_editable_fields={non_editable_fields}
        //show_machine_stats={true}
      />
    </>
  )
}

export default EcocontrolScans
